export type ProductCartRequest = {
  activationId: string;
  productId: string;
  variantId: string;
  url: string;
  quantity: 1;
  quotedPriceMinor: number;
  currency: string;
};
export type ProductCartResult = { status: "added" | "failed" | "unavailable" | "unknown"; cartUrl?: string };
// The installed website adapter operates on the visitor's existing native cart.
export type ProductActionHandler = (request: ProductCartRequest) => Promise<ProductCartResult>;
export type ProductSelectionDetail = { activationId: string; catalogId: string; productId: string; url: string };
export type ProductCard = {
  handle?: string;
  name: string;
  price: string;
  compareAt?: string;
  image: string;
  url: string;
  description: string;
  discovery?: { catalogId: string; productId: string; checkedAt: string };
  commerce?: {
    provider: "shopify_storefront";
    productId: string;
    variantId: string | null;
    checkedAt: string;
    priceMinor: number;
    currency: string;
  };
};

export function normalizeProductDiscovery(value: unknown): ProductCard["discovery"] {
  if (!value || typeof value !== "object" || Array.isArray(value)) return undefined;
  const row = value as Record<string, unknown>;
  if (Object.keys(row).some(key => !["catalogId", "productId", "checkedAt"].includes(key)) ||
      typeof row.catalogId !== "string" || !/^[a-z0-9][a-z0-9-]{0,159}$/.test(row.catalogId) ||
      typeof row.productId !== "string" || !/^[A-Za-z0-9][A-Za-z0-9-]{0,120}$/.test(row.productId) ||
      typeof row.checkedAt !== "string" || !Number.isFinite(Date.parse(row.checkedAt))) return undefined;
  return { catalogId: row.catalogId, productId: row.productId, checkedAt: row.checkedAt };
}

export function productSelectionDetail(product: ProductCard, activationId: string): ProductSelectionDetail | null {
  const discovery = normalizeProductDiscovery(product.discovery), url = safeProductUrl(product.url);
  if (!discovery || product.commerce || !url || !/^[A-Za-z0-9_-]{1,120}$/.test(activationId)) return null;
  return { activationId, catalogId: discovery.catalogId, productId: discovery.productId, url };
}

export function safeProductUrl(value: string): string | null {
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}
